module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "50%",
      "float": "left",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("\n          Membership Summary:\n        ")]), _vm._v(" "), _c('ul', [_c('h3', [_vm._v(_vm._s(_vm.dataPackage.name))]), _vm._v(" "), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.dataPackage.description))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('b', [_vm._v("Price:")]), _vm._v(" $" + _vm._s(_vm.dataPackage.current_price))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "auto",
      "width": "50%",
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "paypal-button-container",
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card_container",
    attrs: {
      "id": "card-form"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-name-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-number-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-expiry-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-cvv-field-container"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "card-field-submit-button",
      "type": "button",
      "disabled": _vm.purchaseDisabled
    },
    on: {
      "click": function($event) {
        _vm.debouncedClick()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('small', [_c('p', [_c('b', [_vm._v("Disclaimer:")]), _vm._v(" All sales are final. Previous results do not indicate future performance. No refunds will be issued.\n            By purchasing a membership, you agree to the terms and conditions\n            outlined in the\n            "), _c('router-link', {
    attrs: {
      "to": {
        path: '/terms'
      }
    }
  }, [_vm._v("terms of service")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        path: '/disclaimer'
      }
    }
  }, [_vm._v(" disclaimer")]), _vm._v(".\n          ")], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Full Access to Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Pick Notifications to Text/Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Access Unit Based Bankroll Strategy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Spacer-module_divider__ewqEj"
  }, [_c('span', [_vm._v("OR")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('p', [_c('b', [_vm._v("Payment:")]), _vm._v(" Payment is processed securely through PayPal/Braintree.\n            Payment information is not accessible or stored by us in any form. We never have access to your payment details.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('p', [_c('b', [_vm._v("One Time Payment:")]), _vm._v(" Memberships are one time payments. We will never charge your account.\n            When your membership expires, you will need to purchase a new membership to continue receiving premium content. This is not a subscription.\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c770e80a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Purchase.vue
// module id = 526
// module chunks = 1